import { IDongBoPhiKyTucXaRequest } from "../../../model/request/dong-bo/IDongBoPhiKyTucXaRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { IDongBoPhiKyTucXaSinhVien } from "../../../model/respone/dong-bo/IDongBoPhiKyTucXaSinhVien";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const edongBoPhiKyTucXaActionsObj = {
  LOAD_START: {} as IDongBoPhiKyTucXaRequest,
  LOAD_SUCCESS: {} as IDongBoPhiKyTucXaSinhVien[],
  LOAD_ERRR: {} as string,

  SYNC_START: {} as IProcessRequest<IDongBoPhiKyTucXaSinhVien[]>,
  SYNC_SUCCESS: {} as string,
  SYNC_ERR: {} as string,

  CLOSE_PROCESSING_MODAL: undefined,
};

export const eDongBoPhiKyTucXaActionTypeIds = generateActionTypeIds(
  edongBoPhiKyTucXaActionsObj,
  "DONG_BO_PHI_KY_TUC_XA"
);
export type IDongBoPhiKyTucXaActionTypes = IGenericActionType<
  typeof edongBoPhiKyTucXaActionsObj,
  "DONG_BO_PHI_KY_TUC_XA"
>;
